import { StrictMode, useEffect } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./styles/rtl.css";
import "./styles/direction.css";
import "./styles/admin-forms.css";
import "./styles/markdown.css";
import "./styles/prevent-scroll.css";
import "./styles/alerts.css";
import Router from "./router";
import { AuthProvider } from "@/hooks/auth/AuthContext";
import { LanguageProvider } from "@/hooks/useLanguage";
import { AlertProvider } from "./components/ui/MacOSAlert";
import { BackgroundProvider } from "./contexts/BackgroundContext";
import { initializeStorageBuckets } from "./lib/storage";
import "./utils/testAuth"; // Import test auth function for debugging
import "./utils/debugAuth"; // Import debug auth function
import "./utils/cookieDebugger"; // Debug cookies vs localStorage
import "./utils/courseDebugger"; // Debug course access issues
import "./utils/cacheCleanup"; // Clean up old localStorage cache
import "./utils/employeeDebugger"; // Debug employee record issues

// Initialize storage buckets when the app starts
initializeStorageBuckets().catch(error => {
  console.error("Error initializing storage buckets:", error);
  // Continue loading the app even if bucket initialization fails
});

const App = () => {
  return (
    <StrictMode>
      <LanguageProvider>
        <AuthProvider>
          <AlertProvider>
            <BackgroundProvider>
              <Router />
            </BackgroundProvider>
          </AlertProvider>
        </AuthProvider>
      </LanguageProvider>
    </StrictMode>
  );
};

createRoot(document.getElementById("root")!).render(<App />);
